// src/config/plans.js

export const FULL_ACCESS_PLANS = ['parcours', 'praticien', 'academia', 'entreprise', 'pro'];
export const UNLIMITED_RUNS_PLANS = ['praticien', 'academia', 'entreprise', 'pro'];

const TRIAL_RUN_LIMIT = 15;

export const PLAN_RUN_LIMITS = {
  freemium:    3,
  decouverte:  8,
  parcours:    25,
  praticien:   Infinity,
  academia:    Infinity,
  entreprise:  Infinity,
  pro:         Infinity,
};

const isInTrialPeriod = (user) => {
  if (!user?.subscription?.trialEndsAt) return false;
  return new Date(user.subscription.trialEndsAt) > new Date();
};

/**
 * Accès à tous les runs (débloque les templates locked)
 * → Pendant l'essai + une fois payé
 */
export const hasFullAccess = (user) => {
  if (!user) return false;
  if (user.role === 'superadmin') return true;

  const plan = user.subscription?.plan;
  if (!FULL_ACCESS_PLANS.includes(plan)) return false;

  // Pendant l'essai → on donne quand même l'accès total
  // On limite seulement le nombre de lancements
  return true;
};

/**
 * Accès illimité (pas de limite de lancements)
 * → Uniquement après paiement (pas pendant l'essai)
 */
export const hasUnlimitedRuns = (user) => {
  if (!user) return false;
  if (user.role === 'superadmin') return true;

  if (isInTrialPeriod(user)) return false;   // limité en nombre pendant l'essai

  const plan = user.subscription?.plan;
  return UNLIMITED_RUNS_PLANS.includes(plan);
};

/**
 * Quota de runs par mois
 */
export const getMaxRunsForPlan = (user) => {
  if (!user) return 3;
  if (user.role === 'superadmin') return Infinity;

  if (isInTrialPeriod(user)) {
    return TRIAL_RUN_LIMIT;        // 15 pendant l'essai
  }

  const plan = user.subscription?.plan;
  return PLAN_RUN_LIMITS[plan] ?? 5;
};